module.exports = __webpack_public_path__ + "static/images/lingqu_btn.2b17520.png";